import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UploadLoginImageResponse {
  webpUrl: string;
  originalUrl: string;
}

export const uploadLoginImageAPI = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await baseAPI.post<UploadLoginImageResponse>(
    '/studios/login-image/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const useUploadLoginImageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: uploadLoginImageAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.STUDIO_DETAILS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.LOGIN_IMAGE] });
    },
  });
};
